/*
 * @Author: Jhonsem
 * @Date: 2019-08-07 17:17:53
 * @Last Modified by: jhonsem
 * @Last Modified time: 2021-03-23 10:39:18
 * 用户永久性存储cookie的
 */

import { formatCookie } from "@/api/utils/api_helpers";
import nativeStorage from "@/utils/nativeStorage/native_storage";
import { PERSIST_COOKIES } from "@/utils/nativeStorage/local_keys";
/**
 * http返回的cookie格式
 */
interface ResponseCookieMap {
  domain?: string;
  value: string;
  name: string;
  path?: string;
  expiresAt?: number;
  secure?: boolean;
  httpOnly?: string;
  hostOnly?: boolean;
  persistent?: boolean;
}
/**
 * 需要存贮的具体cookie
 */
interface CookieMap {
  csrftoken: string;
  ds_user: string;
  ds_user_id: string;
  mid?: string;
  rur?: string;
  sessionid?: string;
  urlgen?: string;
}
class InsCookieHandle {
  public cookieHandle: CookieMap[];
  public initStatus: boolean;

  constructor() {
    this.cookieHandle = [];
    this.initStatus = false;
  }

  /**
   * 初始化cookies_map,从本地存储中拿出放到临时缓存变量内
   */
  public async init() {
    try {
      const cookiePersist = await this.getCookieStorage();
      this.cookieHandle = cookiePersist || [];
      this.initStatus = true;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 存储更新本地cookies
   */
  public saveCookieStorage() {
    nativeStorage.set(PERSIST_COOKIES, this.cookieHandle);
  }

  /**
   * 从本地存储中拿出cookies
   */
  public async getCookieStorage() {
    try {
      const nativeResult: any = await nativeStorage.get(PERSIST_COOKIES);
      return nativeResult;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 从response_cookie中取出cookie,转成cookie_map格式返回出来
   * @param updateCookies
   */
  public getCookieValue(updateCookies: ResponseCookieMap[]) {
    const updateCookieMap: any = {};
    updateCookies.forEach((cookie: ResponseCookieMap) => {
      cookie && (updateCookieMap[cookie.name] = cookie.value);
    });
    return updateCookieMap;
  }

  /**
   *
   * @param updateCookies
   */
  public updateCookie(updateCookies: CookieMap) {
    // 获取到ds_user_id相同的cookie
    const findIndex = this.cookieHandle.findIndex(
      (cookie: CookieMap) =>
        cookie &&
        cookie.ds_user_id &&
        cookie.ds_user_id === updateCookies.ds_user_id
    );

    if (findIndex !== -1) {
      const newCookieMap: any = {
        ...this.cookieHandle[findIndex],
        ...updateCookies
      };
      this.cookieHandle.splice(findIndex, 1, newCookieMap);
    } else {
      // 不相同插入
      this.cookieHandle.push(updateCookies);
    }
    console.log("persist cookie updated:", this.cookieHandle);
    this.saveCookieStorage();
  }

  public async getCookieString(userId: string) {
    const cookie = await this.getCookieMap(userId);
    return cookie && formatCookie(cookie);
  }

  public clearCookie() {
    this.cookieHandle = [];
    this.saveCookieStorage();
  }

  /**
   * 通过user_id来获取到单个的cookie_map
   * @param user_id
   */
  public async getCookieMap(user_id: string) {
    const findCookie = () => {
      return this.cookieHandle.find((cookie: CookieMap) => {
        return cookie && cookie.ds_user_id && cookie.ds_user_id === user_id;
      });
    };

    if (this.initStatus) {
      return findCookie();
    } else {
      await this.init();
      return findCookie();
    }
  }
}

export default new InsCookieHandle();
